export default [

  {
    path: "/edit-record/list",
    name: "edit-records-list",
    component: () => import("@/views/edit-record/edit-records-list/editRecordsList.vue"),
    meta: {
      action: "read",
      resource: "edit_records",
    },
  },
]